
(function () {
    'use strict';

    angular.module('thankview.pricing')
        .directive('overlayPaywall', [function () {
            return {
                restrict: 'E',
                scope: true,
                templateUrl: '/templates/pricing/overlay-paywall.html?v=' + config.version,
                link: function (scope) {
                    scope.$on('open-paywall', function (event, params) {
                        scope.$broadcast('open-overlay');

                        // set whether the paywall can be closed by the user
                        scope.dontClose = params.dontClose;

                        // set which payment will show up in the paywall
                        if (params.payment) {
                            scope.pricing = [params.payment];
                        }
                    });
                },
            };
        }]);
}());
